import React from 'react';
import BooleanInput from '../Form/BooleanInput';
import FormInput from '../Form/FormInput';
import StringSelector from '../Form/StringSelector';
import { Container, Row, Col } from 'reactstrap';
import { FormLabel } from '../Form/FormLabel';
import { useAuth } from '../../Services/AuthContext';

const ClientDetail = ({ invite }) => {
    const [auth] = useAuth();
    //<StringSelector id='catering' label="Catering" list={charterTypes?.catering} />
    //  <BooleanInput id='shared' label='Shared' />
    return <React.Fragment>
        <Container>
            <Row>
                <Col>
                    <Row>
                        <Col>
                            <FormInput id='companyName' label='Company Name' />
                        </Col>
                        <Col>
                            <FormInput id='companyAddress' label='Company Address' />
                        </Col>
                        <Col>
                            <FormInput id='companyPhone' label='Company Phone' type='phone'/>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <FormInput id='firstName' label='First Name' />
                        </Col>
                        <Col>
                            <FormInput id='lastName' label='Last Name' />
                        </Col>
                        <Col>
                            <FormInput readOnly={!invite} id='email' label='Email' type='email' />
                        </Col>
                    </Row>

                </Col>
            </Row>
        </Container>
        <FormInput id='notesForSupplier' label='Notes For Supplier' type='textarea' />
        <Container>
            <Row>
                {auth.role === "Admin" ? <Col>
                    <Row>

                        <Col>
                            <BooleanInput id='canViewSupplierInfo' label='Can View Supplier Info?' />
                        </Col>
                        <Col>
                            <BooleanInput id='hidePrice' label='Hide Price?' />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <StringSelector id='clientType' label="Client Type" stringType list={['Generic', 'QGov']} />
                        </Col>
                    </Row>
                </Col> : null}
                <Col>
                    <Row>
                        <FormLabel>Itinerary Settings</FormLabel>
                    </Row>
                    <Row>
                        <Col>
                            <BooleanInput id='itineraryShowPrice' label='Show price in itinerary?' />
                        </Col>
                        <Col>
                            <FormInput id='itineraryMinutesOffset' label="Itinerary Departure Time offset" type='number' />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <BooleanInput id='itineraryHidePhone' label='Hide Passenger phone numbers?' />
                        </Col>
                        <Col>
                            <BooleanInput id='itineraryShowPrice' label='Show price in itinerary?' />
                        </Col>
                        <Col>
                            <BooleanInput id='itineraryShowSupplier' label='Show Supplier details in itinerary?' />
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>

    </React.Fragment>
};

export default ClientDetail;




